"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GreatAquifer = void 0;
var PreludeCard_1 = require("./PreludeCard");
var CardName_1 = require("../../CardName");
var PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
var CardRenderer_1 = require("../render/CardRenderer");
var GreatAquifer = (function (_super) {
    __extends(GreatAquifer, _super);
    function GreatAquifer() {
        return _super.call(this, {
            name: CardName_1.CardName.GREAT_AQUIFER,
            metadata: {
                cardNumber: 'P13',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.oceans(2);
                }),
                description: 'Place 2 Ocean tiles.',
            },
        }) || this;
    }
    GreatAquifer.prototype.play = function (player) {
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player, 'Select space for first ocean'));
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player, 'Select space for second ocean'));
        return undefined;
    };
    return GreatAquifer;
}(PreludeCard_1.PreludeCard));
exports.GreatAquifer = GreatAquifer;
